import type { AppProps } from "next/app";
import { useEffectOnce } from "react-use";
import { appWithTranslation } from "next-i18next";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";
import DayJsProvider from "@/src/config/DayJSProvider";
import AppProvider from "@/src/config/AppProvider";
import ChatLauncher from "@/src/shared/ChatLauncher/ChatLauncher";
import nextI18NextConfig from "../next-i18next.config.js";

import "bootstrap/scss/bootstrap.scss";

import "../public/scss/default/euclid-circulara.scss";
// ========= Plugins CSS START =========
import "../node_modules/sal.js/dist/sal.css";
import "../public/css/plugins/fontawesome.min.css";
import "../public/css/plugins/feather.css";
import "../public/css/plugins/odometer.css";
import "../public/css/plugins/animation.css";
import "../public/css/plugins/euclid-circulara.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-cards";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
// ========= Plugins CSS END =========
import "../public/scss/styles.scss";
import "../public/css/custom.css";

function App({ Component, pageProps }: AppProps) {
  useEffectOnce(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");
  });

  return (
    <>
      <ProgressBar height="3px" color="#2f57ef" options={{ showSpinner: false }} />
      {pageProps.skipAppRouter ? (
        <Component {...pageProps} />
      ) : (
        <DayJsProvider>
          <AppProvider {...pageProps}>
            <Component {...pageProps} />
            <ChatLauncher />
          </AppProvider>
        </DayJsProvider>
      )}
    </>
  );
}

export default appWithTranslation(App, nextI18NextConfig);
